import { BuilderArticlePageReference } from '@/types/article';
import { BuilderState } from '@/types/builder';
import { CategoryLabelVariant } from '../CategoryLabel/CategoryLabel';

export const ARTICLE_SIDEBAR_NAME = 'ArticleSidebar';
export const ARTICLE_SIDEBAR_DEFAULT_LIMIT = 5;

export interface ArticleSidebarInput {
  tagVariant?: CategoryLabelVariant;
  title: string;
  moreLink: string;
  moreLinkLabel: string;
  autoSelectLatest?: boolean;
  limit?: number;
  articles?: {
    article?: BuilderArticlePageReference;
  }[];
  builderState: BuilderState;
}
